module.exports = __webpack_public_path__ + "img/img-2443bd.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-smilies/dist/angular-smilies.png
// module id = 1758
// module chunks = 12